module.exports = __webpack_public_path__ + "static/media/bg12.d0fd6f05.jpeg";